import axios from 'axios';

const USER_ID_API = '/api/get_supporter_user_id.php';

/**
 * ユーザーIDを取得して返す
 * 無ければ''が返る
 */
export function fetchUserId () {
  return axios(USER_ID_API)
    .then(res => {
      return res.data;
    }).catch(() => {
      return '';
    });
}
